import styled from "styled-components";

export const Container = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid #f7f2fa;
  margin-top: 15px;
`;

export const RowDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: -5px;
`;

export const SizeHeading = styled.p`
  font-size: 16px;
  color: #000000;
  font-family: DM Sans;
  font-weight: 500;
`;
